module.exports = __webpack_public_path__ + "img/389ca34.jpg";